module.exports = __webpack_public_path__ + "img/area.1fc7d310.svg";